export default __webpack_public_path__ + "static/media/usp_4.3e5a07bd.svg";